<div class="ui basic segment">
    <app-header [title]="projectAssignment.project.name" [back]="true"> </app-header>

    <div class="ui segment">
        <app-segment-header title="{{ 'time-tracking.generalInformation' | appTranslate }}"></app-segment-header>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectName' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ projectAssignment.project.name }}</div>
        </div>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectDescription' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ projectAssignment.project.description }}</div>
        </div>
        <div class="app-grid margin-bottom-4" *ngIf="hasOwners()">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectOwners' | appTranslate }}:</label>
            </div>
            <div class="columns-7">
                <span *ngFor="let owner of owners; last as isLast">
                    <a [routerLink]="['/employees', 'directory', owner.id]">{{ owner.fullName }}</a>
                    <ng-container *ngIf="!isLast">, </ng-container>
                </span>
            </div>
        </div>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.myProjectsPage.table.myApprovedHours' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ totalApprovedHours() }}</div>
        </div>
    </div>
</div>
